
// Easify Product Options - Prestige Theme Fix
// Moves Easify container from cart-drawer to main product area
(function() {
  var applied = false;
  
  function moveEasify() {
    if (applied) return true;
    
    // Find Easify in cart-drawer with content
    var cartDrawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
    if (!cartDrawer) return false;
    
    var easifyInDrawer = cartDrawer.querySelector('[data-tpo-theme]');
    if (!easifyInDrawer || easifyInDrawer.innerHTML.length < 100) return false;
    
    // Find main product-info
    var allProductInfos = Array.from(document.querySelectorAll('.product-info'));
    var mainProductInfo = allProductInfos.find(function(el) {
      return !el.closest('[id="cart-drawer"]') && !el.closest('cart-drawer') && el.offsetHeight > 0;
    });
    if (!mainProductInfo) return false;
    
    // Check if already moved
    if (mainProductInfo.querySelector('[data-tpo-theme]')) return true;
    
    // Move (not clone) the Easify element
    // Find the buy-buttons element to insert before it
    var buyButtons = mainProductInfo.querySelector('buy-buttons') || mainProductInfo.querySelector('product-form');
    if (buyButtons) {
      buyButtons.parentNode.insertBefore(easifyInDrawer, buyButtons);
    } else {
      mainProductInfo.appendChild(easifyInDrawer);
    }
    
    applied = true;
    return true;
  }
  
  // Try immediately and at intervals
  var attempts = 0;
  var iv = setInterval(function() {
    attempts++;
    if (moveEasify() || attempts > 20) clearInterval(iv);
  }, 300);
  
  window.addEventListener('load', function() {
    setTimeout(moveEasify, 500);
    setTimeout(moveEasify, 1500);
    setTimeout(moveEasify, 3000);
  });
})();
